$(function (e){
	const checkout_login_modal_element = document.getElementById('checkout_login_modal');
	if( checkout_login_modal_element != 'undefined' && checkout_login_modal_element ){
		const checkout_login_modal = bootstrap.Modal.getOrCreateInstance(checkout_login_modal_element, {backdrop: 'static', keyboard: false});
		handleModalHide(checkout_login_modal_element);
		checkout_login_modal_element.addEventListener('hide.bs.modal', function (event) {
			$('#checkour_order_form').submit();
		});
	}
	
	$('select#district').select2({
		placeholder: Lang.get('js-return-text.select_box_district_placeholder'),
	});

	$('select#province').select2({
		placeholder: Lang.get('js-return-text.select_box_province_placeholder'),
	});


	/* Rebuild district select 2 after province selected */
	$('body').on('select2:select', '#province', function(e){
		var data = e.params.data.id;
		var districts = JSON.parse($('#distinct_province').val());
      	$('#district').html('<option></option>');
      	$.each( districts, function( key, value ) {
      		if( value.province_id == data ){
      			$('#district').append('<option value="'+value.id+'">'+value.district_name+'</option>');
      		}
      	});
		$('#district').select2({
			placeholder: "Select district",
		});
	});

	/* Checkout ajax function */
	$('body').on('click', '#place-order-button', function(e){
		e.preventDefault();
		$(this).addClass('button--secondary--large').attr('disabled', 'disabled').html(Lang.get('js-return-text.btn_processing'));
		var data_url = $(this).attr('data-url');
		var email = $('#email').val();
		var password = $('#password').val();
		if( email && password ){
			var csrf_token = $('meta[name="csrf-token"]').attr('content');
			var data = {
				'_token': csrf_token,
				'name' : $('#name').val(),
	            'phone' : $('#phone').val(),
	            'province' : $('#province').val(),
	            'district' : $('#district').val(),
	            'postcode' : $('#postcode').val(),
	            'address' : $('#address').val(),
	            'paymentMethod' : $('input[name=paymentMethod]').val(),
				'email' : email,
				'password': password,
			};
			$.post(data_url, data).done(function(data) {
				if( data[Object.keys(data)[0]] === 'success' ){
					$('#checkour_order_form').submit();
				}else if( data[Object.keys(data)[0]] === 'failed' ){
					$("#checkout_login_modal #login_email").val(email);
					if( checkout_login_modal && checkout_login_modal != 'undefined' ){
						checkout_login_modal.show();
					}
				}else{
					$.each(data, function(status, value){
	    				if( status !== "paymentMethod" ){
	    					$('#'+status+'[name='+status+']').removeClass('is-valid');
	    					$('#'+status+'[name='+status+']').addClass('is-invalid');
	    					$('#'+status+'[name='+status+']').parent().addClass('invalid-field');
	    				}
	            	});
	            	$('html, body').animate({
			            scrollTop: $('#'+Object.keys(data)[0]+'[name='+Object.keys(data)[0]+']').parent().offset().top
			        }, 1500);
				}
            });
		}else{

			// FB track
			// Check if the fbq function is defined
			var fbq_data = {
				content_catagory: `AddPaymentInfo - ${$('input[name=paymentMethod]:checked').val()}`,
				contents: $('input[name=paymentMethod]:checked').val(),
			};
			// console.log(fbq_data);

			if (typeof fbq === 'function') {
				fbq('track', 'AddPaymentInfo', fbq_data);
			}

			// tiktok track
			if( typeof ttq === 'function' ){
				ttq.instance('CBU8DFBC77UESBO9JCS0').track('AddPaymentInfo', {
					content_catagory: `AddPaymentInfo - ${$('input[name=paymentMethod]:checked').val()}`
				});
			}

			$('#checkour_order_form').submit();
		}
	});

	/* Checkout-login-modal click forgot password button*/
	$('body').on('click', '#open-forgot-form-section', function(e){
		$('#checkout_login_modal .login-form-section').addClass('d-none');
		$('#checkout_login_modal .forgot-form-section').removeClass('d-none');
	});

	/* login_password field onchange remove invalid  */
	$('body').on('change paste keyup', '#checkout_login_modal #login_password', function(e){
		$('#checkout_login_modal #login_email').removeClass('is-invalid');
		$(this).removeClass('is-invalid');
		$(this).parent().parent().removeClass('invalid-field');
	});

	/* Checkout-login-modal login-button-click*/
	$('body').on('click', '#login-button', function(e){
		var email = $("#checkout_login_modal #login_email").val();
		var password = $("#checkout_login_modal #login_password").val();
		var url = $(this).attr('data-url');
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var data = { 
			'email' : email,  
			'password': password,
			'_token': csrf_token 
		};
		$.post(url, data).done(function(data) {
			if( data[Object.keys(data)[0]] === 'success' ){
				if( checkout_login_modal && checkout_login_modal != 'undefined' ){
					checkout_login_modal.hide();
				}
			}else{
				if( data[Object.keys(data)[0]] === 'failed' ){
					$('#checkout_login_modal #login_email').removeClass('is-valid');
    				$('#checkout_login_modal #login_email').addClass('is-invalid');
    				$('#checkout_login_modal #ajaxLoginReturn').html(data[Object.keys(data)[1]]);
				}else{
					$.each(data, function(status, value) {
						$('#checkout_login_modal #login_'+status+'[name=login_'+status+']').removeClass('is-valid');
	    				$('#checkout_login_modal #login_'+status+'[name=login_'+status+']').addClass('is-invalid');
						if( status === "password" ){
							$('#checkout_login_modal #login_'+status+'[name=login_'+status+']').parent().parent().addClass('invalid-field');
						}else{
							$('#checkout_login_modal #login_'+status+'[name=login_'+status+']').parent().addClass('invalid-field');
						}
					});
				}
			}
		});
	});

	/* Checkout-forgot-modal forgot-button-click*/
	$('body').on('click', '#forgot-button', function(e){
		var email = $("#checkout_login_modal #forgot_email").val();
		var url = $(this).attr('data-url');
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var data = { 
			'email' : email,  
			'_token': csrf_token 
		};
		$.post(url, data).done(function(data) {
			if( data[Object.keys(data)[0]] === 'success' ){
				$('#checkout_login_modal .forgot-form-section').addClass('d-none');
				$('#checkout_login_modal .reset-form-section').removeClass('d-none');
			}else{
				if( data[Object.keys(data)[0]] === 'failed' ){
					$('#checkout_login_modal #forgot_email').removeClass('is-valid');
	    			$('#checkout_login_modal #forgot_email').addClass('is-invalid');
	    			$('#checkout_login_modal #ajaxForgotReturn').html(data[Object.keys(data)[1]]);
				}else{
					$.each(data, function(status, value) {
						$('#forgot_'+status+'[name=forgot_'+status+']').removeClass('is-valid');
    					$('#forgot_'+status+'[name=forgot_'+status+']').addClass('is-invalid');
    					$('#forgot_'+status+'[name=forgot_'+status+']').parent().addClass('invalid-field');
					});
				}
			}
		});
	});

	/* Checkout-forgot-modal forgot-button-click*/
	$('body').on('click', '#reset-button', function(e){
		var code = $("#checkout_login_modal #reset_code").val();
		var password = $("#checkout_login_modal #reset_password").val();
		var url = $(this).attr('data-url');
		var csrf_token = $('meta[name="csrf-token"]').attr('content');
		var data = { 
			'code' : code,  
			'password' : password,
			'_token': csrf_token 
		};
		$.post(url, data).done(function(data) {
			if( data[Object.keys(data)[0]] === 'success' ){
				$('#checkout_login_modal .reset-form-section').addClass('d-none');
				$('#checkout_login_modal .login-form-section').removeClass('d-none');
			}else{
				if( data[Object.keys(data)[0]] === 'failed' ){
					$('#checkout_login_modal #reset_code').removeClass('is-valid');
	    			$('#checkout_login_modal #reset_code').addClass('is-invalid');
	    			$('#checkout_login_modal #ajaxResetReturn').html(data[Object.keys(data)[1]]);
				}else{
					$.each(data, function(status, value) {
						$('#reset_'+status+'[name=reset_'+status+']').removeClass('is-valid');
    					$('#reset_'+status+'[name=reset_'+status+']').addClass('is-invalid');
    					$('#reset_'+status+'[name=reset_'+status+']').parent().addClass('invalid-field');
					});
				}
			}
		});
	});
});